import { GlobalImage } from "config/image";
import React from "react";


const AuthLogo = () => (
  <div className="logo-style">
    <div className="d-inline-block auth-logo">
      <img src={GlobalImage.logo} alt="logo" height="32" />
    </div>
  </div>
);

export default React.memo(AuthLogo);
